<script>
    let username = "";
    let email = "";
    let phoneNumber = "";
    let files;
    let src;

    $: if(files) setPreviewImage();
    else src = null;

    function openFileSelect() {
        const fileInput = document.getElementById("fileInput");

        fileInput.click();
    }

    function setPreviewImage() {
        const reader = new FileReader();

        reader.onload = function() {
            src = reader.result;
        }

        reader.readAsDataURL(files[0]);
    }
</script>

<style>    
    .form-container {
        margin-top: 2rem;
    }
    .file-input {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 460px;
        max-width: 95%;
        margin-top: 2rem;
        padding: 0 0 0 .5rem;
        border: 1px solid gray;
        border-radius: 9px;
    }
    .file-input p {
        color: gray;
    }
    .delete {
        font-size: 1.4rem;
        color: #000;
        cursor: pointer;
        vertical-align: middle;
        margin-left: .3rem;
    }

    .delete:hover {
        transition: .12s;
        transform: scale(1.05);
        color: red;
    }
    .preview-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 240px;
        margin-top: 1.5rem;
    }
    .preview-image {
        width: 180px;
    }
    .preview-container button {
        margin-top: 1rem;
    }
</style>


<div class="container">
    <div class="content-container">
        <h1>Lisää käyttäjätiedot</h1>

        <div class="form-container">
            <label class="label" for="username">Käyttäjänimi (näytetään käyttäjille)</label>
            
            <input type="text" id="username" placeholder="esim. Yritys Oy" 
             class="input input-bordered input-primary w-full max-w-xs inp"
             bind:value={ username }
            >

            <label class="label" for="email">Sähköpostiosoite</label>

            <input type="text" id="email" placeholder="yritys@example.com" 
             class="input input-bordered input-primary w-full max-w-xs inp"
             bind:value={ email }
            >

            <label class="label" for="tel">Puhelinnumero</label>

            <input type="text" inputmode="tel" id="tel" placeholder="+358 50 123 123 23" 
             class="input input-bordered input-primary w-full max-w-xs inp"
             bind:value={ phoneNumber }
            >

            <input type="file" id="fileInput" accept="image/*" style="display: none" bind:files={ files }/>

            {#if src}
                <div class="preview-container">
                    <img alt="preview" src={ src } class="preview-image" />

                    <button class="btn btn-ghost" on:click={ () => files = null }>
                        Poista kuva
                        <span class="material-icons delete">delete</span>
                    </button>
                </div>
            {/if}
            <div class="file-input">
                <p>
                    {#if files}
                        { files[0].name }
                    {:else}
                        Ei valittua kuvaa
                    {/if}
                </p>

                <button class="btn btn-primary" on:click={ openFileSelect }>Valitse profiilikuva</button>
            </div>
        </div>
    </div>
</div>